import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { MetricLabel } from "./metric-label";
import { ACTIVE_TEXT, useActiveRow } from "./statement-item-action";
import { StatementItemActionButton } from "./statement-item-action-button";
import type { TotalsBlock } from "./statement-schema";

const TotalsItem = ({
  item,
  heading,
}: {
  item: TotalsBlock["items"][number];
  heading?: string;
}) => {
  const active = useActiveRow({
    heading,
    line: item.label ?? undefined,
    amount: item.value,
  });

  return (
    <Stack gap={0} align="end" className="gap-0.5">
      <Stack direction="row" align="center" gap={0}>
        <MetricLabel>{item.label}</MetricLabel>
        <StatementItemActionButton
          heading={heading}
          line={item.label ?? undefined}
          amount={item.value}
        />
      </Stack>
      <Text variant="label">
        <span className={cn({ [ACTIVE_TEXT]: active })}>{item.value}</span>
      </Text>
    </Stack>
  );
};

export const Totals = ({ block }: { block: TotalsBlock }) => (
  <Stack
    className="w-full"
    direction="row"
    align="center"
    justify="between"
    gap={4}
  >
    <Text
      variant="label"
      className="text-xs font-medium tracking-widest uppercase"
      tone="muted"
    >
      {block.label}
    </Text>
    <Stack direction="row" gap={6} align="end" className="flex-wrap">
      {block.items.map((item, index) => (
        <TotalsItem
          key={index}
          item={item}
          heading={block.label ?? undefined}
        />
      ))}
    </Stack>
  </Stack>
);
